import { SORT_TYPE } from '@/utils/constants';
import { SORT_BY } from '@features/insurance/constants';
import {
  TInsuranceSearchPayload,
  TInsuranceSearchResponse,
  TPolicyData,
} from '@features/insurance/types';
import { makeAutoObservable } from 'mobx';

export class InsuranceDataStore {
  insuranceFilter: TInsuranceSearchPayload = {
    sortType: SORT_TYPE.ASCENDING,
    sortBy: SORT_BY.PRICE,
  } as TInsuranceSearchPayload;
  insuranceData: TInsuranceSearchResponse = {} as TInsuranceSearchResponse;
  selectedInsurance: TInsuranceSearchResponse = {} as TInsuranceSearchResponse;
  policy: TPolicyData = {} as TPolicyData;
  selectedOptions: Record<string, number> = {} as Record<string, number>;

  constructor() {
    makeAutoObservable(this);
  }

  setInsuranceFilter = (insuranceFilter: TInsuranceSearchPayload) => {
    this.insuranceFilter = insuranceFilter;
  };

  setInsuranceData = (insuranceData: TInsuranceSearchResponse) => {
    this.insuranceData = insuranceData;
  };

  setSelectedInsurance = (selectedInsurance: TInsuranceSearchResponse) => {
    this.selectedInsurance = selectedInsurance;
  };

  setPolicy = (policy: TPolicyData) => {
    this.policy = policy;
  };

  setSelectedOptions = (selectedOptions: Record<string, number>) => {
    this.selectedOptions = selectedOptions;
  };
}

const insuranceDataStore = new InsuranceDataStore();

export default insuranceDataStore;
